import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { createRenderer } from 'fela';
import { Provider } from 'react-fela';
import { namedMediaQueryPlugin } from './util/namedMediaQueries';

const renderer = createRenderer({
  plugins: [namedMediaQueryPlugin],
});

ReactDOM.render(
  <Provider renderer={ renderer }>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js